export class ConformiteFournitures {

	public precisions: string;

	constructor() { 
		 		this.precisions = '';
 
	}
}
